import { render, staticRenderFns } from "./update-profile-icon.vue?vue&type=template&id=252ce876&scoped=true&"
import script from "./update-profile-icon.vue?vue&type=script&lang=js&"
export * from "./update-profile-icon.vue?vue&type=script&lang=js&"
import style0 from "./update-profile-icon.vue?vue&type=style&index=0&id=252ce876&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ce876",
  null
  
)

export default component.exports